<template>
    <pokemon-builder />
</template>

<script>
    import Vue from 'vue'
    import PokemonBuilder from './PokemonBuilder'

    export default Vue.extend({
        components: {
            PokemonBuilder
        }
    })

    
</script>